// extracted by mini-css-extract-plugin
export default {"tooltip":"dDg9Rk","bubble":"l2Nfc6","tooltipTriangle":"sm4axf"};